var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"img-pdetail-list",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleChange(_vm.src)}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],attrs:{"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }